import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';
import TextFormField from 'CommonComponents/TextFormField';

import useMutation from 'Hooks/useMutation';

const ProjectCategorySchema = Yup.object().shape({
    category_id: Yup.number().nullable(),
    description: Yup.string().required($t('This value is required')),
});

export default function EditCategoryModal(props) {
    const close = () => {
        props.modal.hide();
    };

    const onUpdated = () => {
        close();
        props.onUpdated();
    };

    const categoryMutation = useMutation({
        successMessage: $t('Project Category updated successfully'),
        mutationFn: (newCategory) => {
            const url = props.updateUrl.replace('CATEGORY_ID', props.category.id);
            return axios.put(url, newCategory);
        },
    });

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader dark title={props.category?.category_id ? $t('Edit Subcategory') : $t('Edit Category')} close={close}></ModalHeader>
            <div className="tw-rounded-b">
                {props.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div className="modal__form-container">
                        <Formik
                            enableReinitialize
                            initialValues={{
                                category_id: props.category?.category_id || null,
                                description: props.category?.description || '',
                            }}
                            validationSchema={ProjectCategorySchema}
                            onSubmit={(values, actions) => {
                                categoryMutation
                                    .mutate(values)
                                    .then((res) => {
                                        actions.resetForm();
                                        onUpdated();
                                    })
                                    .catch((e) => {
                                        e?.response?.data?.errors && actions.setErrors(e?.response?.data?.errors);
                                    })
                                    .finally(() => actions.setSubmitting(false));
                            }}
                        >
                            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => {
                                return (
                                    <div>
                                        <TextFormField label={$t('Name')} required={true} type="text" name="description" />

                                        <div className="modal__footer tw-mt-7">
                                            <Button variant="secondary" onClick={close} disabled={isSubmitting}>
                                                {$t('Cancel')}
                                            </Button>
                                            <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                                                {$t('Save')}
                                            </Button>
                                        </div>
                                    </div>
                                );
                            }}
                        </Formik>
                    </div>
                )}
            </div>
        </Modal>
    );
}
